import React from "react";

import { ColumnDef } from "@tanstack/react-table";
import { Loader } from "../components/simple/loader";
import { LocalTable } from "../components/table";
import { ThreePanelLayout } from "../layouts/threePanel";
import { Teacher } from "../providers/context";
import { useRequest } from "../request";
import { TextInput } from "../components/form/textInput";

type DeliveredMessage = {
  date: string;
  type: string;
  from: string;
  to: string;
  body: string;
  status: string;
  sid: string;
};

const deliveredMessageColumns: ColumnDef<DeliveredMessage>[] = [
  {
    accessorKey: "date",
    header: "Date",
  },
  {
    accessorKey: "type",
    header: "Type",
  },
  {
    accessorKey: "from",
    header: "From",
  },
  {
    accessorKey: "to",
    header: "To",
  },
  {
    accessorKey: "body",
    header: "Body",
  },
  {
    accessorKey: "status",
    header: "Status",
  },
  {
    accessorKey: "sid",
    header: "SID",
  },
];

export const DeliveryStatusPage: React.FC<{
  user: Teacher;
  id?: number;
  incoming?: string;
}> = ({ user, id, incoming }) => {
  const { data, reload } = useRequest<DeliveredMessage[]>(
    "/frontend_api/deliveryStatus/" + id + "/" + incoming
  );
  const [search, setSearch] = React.useState<string>("");

  const messageHeaderText = incoming
    ? "Messages from this number"
    : "Messages to this email/phoneNumber";

  return (
    <ThreePanelLayout noMobile user={user} left={<></>}>
      {data === undefined ? (
        <Loader />
      ) : (
        <div className="flex flex-col items-start gap-4 overflow-auto bg-lightBlue p-4">
          <div className="flex w-full flex-col gap-2 rounded-lg bg-white p-4 shadow-lg">
            <div className="flex flex-row items-center justify-between gap-4">
              <div className="ml-1 text-xl font-bold">{messageHeaderText}</div>
              <TextInput
                placeholder="Search"
                value={search}
                onChange={setSearch}
              />
            </div>
            <LocalTable
              columns={deliveredMessageColumns}
              data={data}
              pagination={20}
              search={search}
            />
          </div>
        </div>
      )}
    </ThreePanelLayout>
  );
};
